import { Modal } from './Modal.jsx';
import { useT, SUPPORTED } from '../i18n/index.js';
import { useConfig } from '../store/configStore.js';
import { Icon } from './Icon.jsx';
import { Flag } from './Flag.jsx';

export function SettingsModal({ open, onClose }) {
  const t = useT();
  const lang = useConfig((s) => s.config.settings.language);
  const setPath = useConfig((s) => s.setPath);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('settings.title')}
      footer={<button className="btn primary sm" onClick={onClose}>{t('modal.close')}</button>}
    >
      <div className="col" style={{ gap: 8 }}>
        <div style={{ fontWeight: 600 }}>{t('settings.language')}</div>
        <div className="lang-list">
          {SUPPORTED.map((l) => (
            <button
              key={l.code}
              className={`lang-item ${l.code === lang ? 'active' : ''}`}
              onClick={() => setPath('settings.language', l.code)}
            >
              <Flag code={l.flagCode} size={22} />
              <span className="lang-label">{l.label}</span>
              {l.code === lang && <Icon name="check" size={14} />}
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
}
